import { useTranslation } from '@/i18n';

const NoDistributorFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex p-10 justify-center items-center">
      <div className="flex flex-col items-center">
        <img
          src="/images/EmptyInbox.png"
          alt="No distributor found"
          className="size-96"
        />
        <p className="text-brand-700">{t('distributors.noDistributorFound')}</p>
      </div>
    </div>
  );
};

export default NoDistributorFound;
